import { c as _c } from "react/compiler-runtime";
export default function TooltipTrigger() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span aria-hidden="true" className="mask-icon mask-icon-help-outline" style={{
      width: "13px",
      height: "13px",
      backgroundColor: "#64666A"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}